var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orderlist bj order-container" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.from1 },
        on: {
          Refresh: _vm.Refresh,
          search: _vm.search,
          selectAllChange: _vm.cityChange,
          changeAmt: _vm.changeAmt,
        },
        scopedSlots: _vm._u(
          [
            _vm.totalObj.is_show && _vm.totalObj.is_show == 1
              ? {
                  key: "left",
                  fn: function () {
                    return [
                      _c("span", { staticClass: "mr10" }, [
                        _vm._v(
                          " 订单总金额：" +
                            _vm._s(_vm.totalObj.order_amt) +
                            "元"
                        ),
                      ]),
                      _c("span", { staticClass: "mr10" }, [
                        _vm._v(
                          " 总件数：" + _vm._s(_vm.totalObj.total_qty) + "件"
                        ),
                      ]),
                      _c("span", { staticClass: "mr10" }, [
                        _vm._v(
                          " 总吨数：" +
                            _vm._s(_vm.totalObj.tonnage_total) +
                            "吨"
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          " 总下单人数：" +
                            _vm._s(_vm.totalObj.member_total) +
                            "人"
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "right",
              fn: function () {
                return [
                  _vm.totalObj.is_show_export &&
                  _vm.totalObj.is_show_export == 1
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "warning",
                            disabled:
                              !_vm.tableData.length || _vm.disabledExport,
                            icon: "el-icon-upload2",
                          },
                          on: { click: _vm.onHandleExport },
                        },
                        [_vm._v("导出")]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "100px",
                  align: "center",
                  label: "序号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logistic_business",
                  align: "center",
                  label: "集配中心",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.logistic_business
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$empty.empty(
                                    scope.row.logistic_business.name
                                  )
                                )
                              ),
                            ])
                          : _c("span", [_vm._v("—")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "order_no", align: "center", label: "订单编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.order_no)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "trade_no",
                  align: "center",
                  label: "微信交易单号",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.trade_no || "—") + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  align: "center",
                  label: "订单创建时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$empty.empty(scope.row.create_time)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "pay_at", align: "center", label: "客户名称" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.member
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$empty.empty(scope.row.member.fullname)
                                  ) +
                                  " "
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { prop: "pay_at", align: "center", label: "客户电话" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.member
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$empty.empty(scope.row.member.mobile)
                                  ) +
                                  " "
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { prop: "pay_app_id", align: "center", label: "商户号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "pay_at", align: "center", label: "支付时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.$empty.time(scope.row.pay_at)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", label: "订单状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.state == 1
                          ? _c("span", [_vm._v("待付款")])
                          : scope.row.state == 2
                          ? _c("span", [_vm._v("已付款")])
                          : scope.row.state == 3
                          ? _c("span", [_vm._v("已取消")])
                          : scope.row.state == 4 && scope.row.supply == 2
                          ? _c("span", [_vm._v("订货中")])
                          : scope.row.state == 4
                          ? _c("span", [_vm._v("已生成供货单")])
                          : scope.row.state == 5
                          ? _c("span", [_vm._v("已完成")])
                          : _c("span", [_vm._v("—")]),
                      ]
                    },
                  },
                ]),
              }),
              !_vm.is_tmp_user
                ? _c("el-table-column", {
                    attrs: { prop: "name", align: "center", label: "订单金额" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$empty.empty(
                                      _vm.tool.format_money(scope.row.order_amt)
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      367128772
                    ),
                  })
                : _vm._e(),
              !_vm.is_tmp_user
                ? _c("el-table-column", {
                    attrs: {
                      prop: "ori_order_amt",
                      align: "center",
                      label: "支付总金额",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (scope.row.ori_order_amt &&
                                      (scope.row.ori_order_amt / 100)?.toFixed(
                                        2
                                      )) ||
                                      "-"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3134594561
                    ),
                  })
                : _vm._e(),
              !_vm.is_tmp_user
                ? _c("el-table-column", {
                    attrs: {
                      prop: "real_order_diff_amt",
                      align: "center",
                      label: "退差价总金额",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (scope.row.real_order_diff_amt &&
                                      (
                                        scope.row.real_order_diff_amt / 100
                                      )?.toFixed(2)) ||
                                      "-"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      106764161
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", label: "城市仓" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.store_delivery &&
                          scope.row.store_delivery.logistics
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$empty.empty(
                                      scope.row.store_delivery.logistics.name
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { prop: "name", align: "center", label: "自提点" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.store_delivery
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$empty.empty(
                                      scope.row.store_delivery.name
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.is_tmp_user
                          ? _c(
                              "router-link",
                              {
                                staticClass: "main-color pointer text-none",
                                attrs: {
                                  to: {
                                    name: "orderDetail",
                                    query: { id: scope.row.id },
                                  },
                                },
                              },
                              [_vm._v("查看详情 ")]
                            )
                          : _vm._e(),
                        scope.row.is_payment_order
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandlePay(scope.row)
                                  },
                                },
                              },
                              [_vm._v("确认已付款")]
                            )
                          : _vm._e(),
                        _vm.is_change_order &&
                        scope.row.supply == 0 &&
                        scope.row.state == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.oncancel(scope.row)
                                  },
                                },
                              },
                              [_vm._v("取消订单")]
                            )
                          : _vm._e(),
                        _vm.is_change_order &&
                        scope.row.supply == 0 &&
                        scope.row.state == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onChange(scope.row)
                                  },
                                },
                              },
                              [_vm._v("变更自提点")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.from1.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("cancelOfOrder", {
        ref: "cancelOfOrder",
        on: { cancelOfOrder: _vm.cancelOfOrder },
      }),
      _c("ChangeSelfPickupPoint", {
        ref: "ChangeSelfPickupPoint",
        on: { cityConfirm: _vm.cityConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }